import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: relative;
  margin-left: 8px;
  flex: 1;
  max-width: 200px;
`;

export const ListWapper = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: 302px;
  z-index: 10;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background-color: var(--colorBlueGray50);
  max-height: 246px;
  margin-bottom: 8px;
  overflow-y: scroll;
`;
